export const ENV = process.env.REACT_APP_ENV;
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const COGNITO_CLIENT_ID = process.env.REACT_APP_COGNITO_CLIENT_ID;
export const COGNITO_POOL_ID = process.env.REACT_APP_COGNITO_POOL_ID;

export const MOBILE_BREAKPOINT = '576';
export const MOBILE_BREAKPOINT_PX = `${MOBILE_BREAKPOINT}px`;

export const FRNT_VER = ' f.230306';
